'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nx = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.update_value_on_change = update_value_on_change;
exports.update_radio_value_on_change = update_radio_value_on_change;
exports.build_options = build_options;

var _nexusui = require('nexusui');

var _nexusui2 = _interopRequireDefault(_nexusui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nx = exports.nx = window.nx = {};

/* ui - update an int/float value */

function update_value_on_change(el, id, is_int, fn) {
  var label = document.querySelector(id + ' + .val');
  var update = function update(v) {
    label.innerHTML = is_int ? parseInt(v) : v.toFixed(2);
    fn && fn(v);
  };
  el.on('change', update);
  update(el.value);
  el.update = update;
}

/* ui - update a radio button */

function update_radio_value_on_change(el, id, values, fn) {
  var old_v = el.active;
  var label = document.querySelector(id + ' + .val');
  var update = function update(v) {
    if (v === -1) {
      v = el.active = old_v;
    } else {
      old_v = v;
    }
    label.innerHTML = values[v][1];
    fn && fn(v);
  };
  el.on('change', update);
  update(el.active);
  el.update = update;
}

/* ui - bind/build a select dropdown */

function build_options(el, lists, fn) {
  (0, _keys2.default)(lists).forEach(function (key) {
    var list = lists[key];
    var option = document.createElement('option');
    option.innerHTML = list.name;
    option.value = key;
    el.appendChild(option);
  });
  el.addEventListener('input', function (e) {
    fn(e.target.value);
  });
}


//////////////////
// WEBPACK FOOTER
// ./client/lib/ui.js
// module id = 69
// module chunks = 0